import type { Page } from '../../types';

const suspectedBribery: Page[] = [
  {
    pageType: 'question',
    title: 'Allegations of suspected bribery',
    name: 'suspected-bribery-declare',
    questions: [
      {
        questionType: 'radio',
        title: 'Do you have any allegations of suspected bribery to declare?',
        name: 'bribery_allegations_declare',
        options: ['Yes', 'No'],
        rules: { required: true },
      },
    ],
  },
  {
    pageType: 'question',
    title: 'Allegations of suspected bribery',
    name: 'suspected-bribery',
    type: 'nilreturn',
    fastToggle: true,
    total: {
      columns: [
        { title: 'Number of instances', field: 'bribery_allegations' },
        { title: 'Total Value', field: 'bribery_allegations_total' },
      ],
    },
    disabled: [
      {
        field: 'bribery_allegations_declare',
        condition: 'equals',
        value: 'No',
      },
    ],
    questions: [
      {
        questionType: 'instanceInput',
        title: 'Total number of instances',
        name: 'bribery_allegations',
        hint: 'If a value is not applicable, please enter 0',
        hideOptionalLabel: true,
        rules: {
          required: true,
          decimal: 'decimal(2)',
        },
      },
      {
        questionType: 'costInput',
        displaySeperator: 'thousand',
        title: 'Estimated total value',
        name: 'bribery_allegations_total',
        hint: '',
        rules: {
          required: false,
          decimal: 'decimal(2)',
        },
      },
      {
        questionType: 'textarea',
        title: 'Comments',
        hideOptionalLabel: true,
        name: 'bribery_allegations_comments',
        hint: 'Please ensure you do not include any personal or sensitive information',
        rules: {
          required: false,
        },
      },
    ],
  },
];
export default suspectedBribery;




